import React from 'react';
import { Box, Paper, Typography, Stack } from '@mui/material';

export default function MobileListCard({
  title,
  leading,
  sx,
  onDragEnter,
  onDragOver,
  onDragLeave,
  onDrop,
  subtitle,
  meta,
  statusSummary,
  children,
  actions,
  primaryAction,
  secondaryAction,
  onClick,
}) {
  return (
    <Paper
      onClick={onClick}
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      sx={{
        p: 1.5,
        borderRadius: 2,
        mb: 1.25,
        backgroundColor: 'background.paper',
        ...(onClick ? { cursor: 'pointer' } : {}),
        ...sx,
      }}
      elevation={0}
    >
      <Stack spacing={0.75}>
        <Stack direction='row' alignItems='flex-start' justifyContent='space-between' gap={1}>
          {leading}
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography
              variant='subtitle2'
              sx={{
                fontWeight: 700,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
              }}
            >
              {title || 'Untitled'}
            </Typography>
          </Box>
          {((!leading && primaryAction) || secondaryAction) && (
            <Stack direction='row' spacing={0.25} onClick={(e) => e.stopPropagation()}>
              {!leading && primaryAction}
              {secondaryAction}
            </Stack>
          )}
        </Stack>
        {subtitle ? (
          <Typography
            variant='body2'
            color='text.secondary'
            sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          >
            {subtitle}
          </Typography>
        ) : null}
        {statusSummary ? <Box sx={{ minHeight: 20 }}>{statusSummary}</Box> : null}
        {(meta || (leading && primaryAction)) && (
          <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={1}>
            <Typography
              variant='caption'
              color='text.secondary'
              sx={{ minWidth: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              {meta}
            </Typography>
            {leading && primaryAction && <Box onClick={(event) => event.stopPropagation()}>{primaryAction}</Box>}
          </Stack>
        )}
        {children ? <Box sx={{ mt: 0.25 }}>{children}</Box> : null}
        {actions ? (
          <Box sx={{ mt: 0.5 }} onClick={(e) => e.stopPropagation()}>
            {actions}
          </Box>
        ) : null}
      </Stack>
    </Paper>
  );
}
